import { voiceData } from '../util/showcaseData';

export const homeVoices = voiceData;

export const voiceLibraryCount = voiceData.length;
